import { useState } from 'react'

import { Splash } from '@/components/common/Splash'
import { type NavItemType } from '@/defs/nav'
import { cn } from '@/utils/commonUtil'

import styles from '../MenuNavMain.module.scss'
import { MenuNavMainButton } from '../MenuNavMainButton/MenuNavMainButton'
import { MenuNavMainInner } from '../MenuNavMainInner/MenuNavMainInner'

type Props = {
  item: NavItemType
}

export const MenuNavMainFlyin = ({ item }: Props) => {
  const [openItem, setOpenItem] = useState<string | false>(false)

  return (
    item.submenu && (
      <ul className={styles.menuFlyIn}>
        {item.backgroundImage && (
          <li aria-hidden className={styles.itemFlyInBackground}>
            <div className={styles.background}>
              <Splash backgroundImages={[item.backgroundImage]} />
            </div>
          </li>
        )}
        {item.submenu.map((itemInner) => (
          <li
            className={cn(styles.itemFlyIn, {
              hasLink: !!itemInner.route,
              hasSubmenu: itemInner.label !== undefined && !!itemInner.submenu,
              isOpen: openItem === itemInner.id,
              styles,
            })}
            key={itemInner.id}
          >
            <MenuNavMainButton
              className={styles.buttonInner}
              item={itemInner}
              onClick={itemInner.submenu ? (id) => setOpenItem(id === openItem ? false : id) : undefined}
              showCaret
            />
            {itemInner.submenu && <MenuNavMainInner item={itemInner} />}
          </li>
        ))}
      </ul>
    )
  )
}
